// removed by extract-text-webpack-plugin
module.exports = {"DeliverySummary":"DeliverySummary__DeliverySummary__1fPVa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeliverySummary/DeliverySummary.css
// module id = 225
// module chunks = 1